/* HAG Office Theme – small, dependency-free helpers */
(function () {
  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: currency });
  }

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-change'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    if (btn.hasAttribute('data-submit')) {
      var form = btn.closest('form');
      if (form) form.submit();
    }
  });

  /* Product variant picker */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var section = form.closest('[data-section]') || document;
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare-price]');
    var addBtn = form.querySelector('[data-add-button]');
    var mainImg = section.querySelector('[data-main-image]');

    function selected() {
      return product.options.map(function (_, i) {
        var checked = form.querySelector('input[data-option-index="' + i + '"]:checked');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = selected();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      opts.forEach(function (val, i) {
        var label = form.querySelector('[data-option-value="' + i + '"]');
        if (label) label.textContent = val || '';
      });
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable'); }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var prepayEl = section.querySelector('[data-prepay]'); if (prepayEl) prepayEl.textContent = formatMoney(Math.round(variant.price * 0.95));
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.getAttribute('data-available') : addBtn.getAttribute('data-soldout');
      }
      if (mainImg && variant.featured_image) {
        mainImg.src = variant.featured_image.src + (variant.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
        mainImg.removeAttribute('srcset');
        mainImg.alt = variant.featured_image.alt || product.title;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('input[data-option-index]')) update();
    });
  });

  /* Product thumbnails */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var section = thumb.closest('[data-section]');
    var main = section && section.querySelector('[data-main-image]');
    if (!main) return;
    main.src = thumb.getAttribute('data-thumb');
    main.removeAttribute('srcset');
    section.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
    thumb.setAttribute('aria-current', 'true');
  });

  /* Collection filters + sort: submit on change */
  document.querySelectorAll('[data-facets-form]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });

  /* Close open filter dropdowns when clicking elsewhere */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.facet[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* Scroll reveal */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.Shopify && Shopify.designMode) return;
    var sel = '.section .eyebrow, .section h2, .section .lead, .card, .tile, .trust__item, .story-specs__media, .story-designer__media, .story-designer__facts > div, .video-block, .band__cards > *';
    var els = Array.prototype.slice.call(document.querySelectorAll(sel)).filter(function (el) {
      return el.getBoundingClientRect().top > window.innerHeight * 0.9;
    });
    if (!els.length) return;
    document.documentElement.classList.add('js-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      if (el.matches('.card, .tile, .trust__item, .story-designer__facts > div, .band__cards > *')) el.style.setProperty('--d', Math.min(sib, 5) * 0.08 + 's');
      el.setAttribute('data-reveal', '');
      io.observe(el);
    });
  })();

  /* Click-to-load video (YouTube/Vimeo erst nach Klick, wegen Datenschutz) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-video-src]');
    if (!btn) return;
    var f = document.createElement('iframe');
    f.src = btn.getAttribute('data-video-src');
    f.title = btn.getAttribute('data-video-title') || 'Video';
    f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    f.allowFullscreen = true;
    btn.parentNode.replaceChild(f, btn);
  });
})();
